<template>
  <Card>
    <AjaxForm route="admin/Manager/Add">
      <div class="row">
        <div class="col-12 col-md-4">
          <CustomInput type="text" input_style="twoLine" name="fullname" label="نام کامل"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput type="text" input_style="twoLine" name="phone" label="تلفن تماس"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput type="text" input_style="twoLine" name="email" label="ایمیل"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput type="text" input_style="twoLine" name="username" label="نام کاربری"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput type="select" input_style="twoLine"
                       :select-options="roleOptions" select-label="title"
                       v-model="selected_role"
                       placeholder="نقش کاربری را انتخاب کنید" name="role" reduce_select="value" label="نقش کاربری"></CustomInput>
        </div>
        <div class="col-12 col-md-4">
          <CustomInput type="text" input_style="twoLine" name="password" label="گذرواژه"></CustomInput>
        </div>
      </div>
      <div class="row">
        <div class="col-10 col-md-5 mx-auto my-3">
          <button class="btn btn-info btn-block" type="submit">افزودن مدیر</button>
        </div>
      </div>
    </AjaxForm>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {AppApi} from "@/api/AppApi";
import {getAdminRoles} from "@/shared/helper";
export default {
name: "ManagerAdd",
  components: {CustomInput, AjaxForm, Card},
  data()
  {
    return{
      roleOptions : getAdminRoles(),
      selected_role : null,
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('افزودن مدیر');
    this.setShowHead(true);
  },
  methods :{
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>